const TRACKING_STORAGE_KEY = "zillout_exp_tracking";
/**
 * Get stored tracking data.
 */
export function getTrackingData() {
    const storedData = sessionStorage.getItem(TRACKING_STORAGE_KEY);
    if (storedData) {
        try {
            return JSON.parse(storedData);
        }
        catch {
            // Invalid JSON, return defaults
        }
    }
    return {
        utmSource: null,
        utmMedium: null,
        utmCampaign: null,
        referrer: null,
        capturedAt: new Date().toISOString(),
    };
}
/**
 * Build URL query string with tracking parameters.
 * Appends UTM params to an existing URL and preserves any existing query params from the current page.
 */
export function appendTrackingParams(baseUrl) {
    const tracking = getTrackingData();
    const url = new URL(baseUrl);
    if (typeof window !== "undefined") {
        const currentParams = new URLSearchParams(window.location.search);
        currentParams.forEach((value, key) => {
            if (!url.searchParams.has(key)) {
                url.searchParams.set(key, value);
            }
        });
    }
    if (tracking.utmSource) {
        url.searchParams.set("utm_source", tracking.utmSource);
    }
    if (tracking.utmMedium) {
        url.searchParams.set("utm_medium", tracking.utmMedium);
    }
    if (tracking.utmCampaign) {
        url.searchParams.set("utm_campaign", tracking.utmCampaign);
    }
    if (tracking.referrer) {
        url.searchParams.set("referrer", tracking.referrer);
    }
    return url.toString();
}
